import { ReactNode } from 'react';
import { ModelRun, MarketAggregatesState } from './types';
import { VariableType } from '../types/dashboard.types';
import { ChartMode } from '../components/chart-card/types';
import type { MarketZoneId } from '@app/common/static-data/energy-markets';

// Actions for updating state
export interface MarketAggregatesContextType {
  state: MarketAggregatesState;
  toggleModelSelection: (modelId: string) => void;
  updateModelRuns: (modelId: string, runs: ModelRun[]) => void;
  resetAllSelections: () => void;
  setWeightType: (weightType: 'population' | 'wind_capacity' | 'solar_capacity') => void;
  setMaxLeadTimeHours: (hours: number) => void;
  // Available zones methods
  fetchAvailableZones: (
    weightType: 'population' | 'wind_capacity' | 'solar_capacity',
  ) => Promise<void>;
  // Chart data methods
  fetchChartData: (
    selectedVariable: VariableType,
    selectedZone: MarketZoneId | MarketZoneId[] | null,
    chartMode: ChartMode,
    selectedBaseline?: string | null,
  ) => Promise<void>;
  clearChartData: () => void;
}

export interface MarketAggregatesProviderProps {
  children: ReactNode;
  initialState?: Partial<MarketAggregatesState>;
}

export const INITIAL_STATE: MarketAggregatesState = {
  availableModels: [],
  weightType: 'wind_capacity', // Default to wind capacity weighting to match default variable 'wind'
  maxLeadTimeHours: 120, // Default forecast horizon: 5 days
  loading: true,
  error: null,
  availableZones: [],
  availableZonesLoading: true, // Start loading to prevent initial flickering
  chartData: {
    data: [],
    loading: false,
    error: null,
    availableBaselines: [],
    cacheKey: '',
    timestamp: 0,
  },
};
